import React, {useContext, useState} from "react";
import {useDispatch} from "react-redux";
import {Grid, FormHelperText, TextField, Typography} from "@leap4/frontend";
import {TypeParamsForm} from "../base/TypeParams/TypeParamsForm";
import {GroupContext} from "./GroupContex";

export interface IDetailsFormProps {
    mode: "create" | "edit"
}

const DetailsForm = (props: IDetailsFormProps) => {
    const {group, setGroup} = useContext(GroupContext);

    const onChange = (e: any) => {
        let {name, value} = e.target;
        setGroup({...group, [name]: value});
    }


    return (
        <>
            <Typography fontFamily={"Quicksand"} fontWeight={600} variant="h5">
                GROUP INFO
            </Typography>

            <Grid container gap={"10px"}>
                <Grid item width='100%'>
                    <FormHelperText>
                        Name
                    </FormHelperText>
                    <TextField
                        autoFocus
                        fullWidth
                        value={group?.name}
                        onChange={onChange}
                        size="small"
                        variant="outlined"
                        name="name"
                        className={"gridItem"}
                    />
                </Grid>

                <Grid item width='100%'>
                    <TypeParamsForm />
                </Grid>
            </Grid>

        </>
    )
}

export {DetailsForm}


